<template>
  <div class="container_box details_box_styles">
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover class="reset_card_head_style">
        <template #title>
          <div class="options_box_style">
            <h2 class="title_box">{{ $t('key1001337') }}</h2>
            <Button type="primary" @click="warehouseRulesBtn('add')"
              v-if="getPermission('ymsDistributorWarehouseAutoRule_insert')">{{ $t('key1006454') }}</Button>
          </div>
        </template>
        <!--头部筛选区域-->
        <div class="filter-box">
          <Form ref="pageParam" :model="pageParam" :label-width="labelWidth" @submit.native.prevent>
            <Row type="flex" :gutter="gutterItem">
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1006452')" prop="status">
                  <Select v-model="pageParam.status">
                    <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1001437')" prop="name">
                  <Input :placeholder="$t('key1006453')" v-model.trim="pageParam.name"></Input>
                </Form-item>
              </Col>
              <Col style="min-width: 170px;" push="1">
                <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
                <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
              </Col>
            </Row>
          </Form>
        </div>
        <!--列表区域-->
        <div class="table-box">
          <Table
            ref="dragable"
            highlight-row
            border
            max-height="650"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
        </div>
      </Card>
    </div>
    <!--查看、编辑仓库规则弹窗-->
    <ruleTemp ref="ruleTemp" :ruleType="ruleType" @updateData="search"></ruleTemp>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import Sortable from 'sortablejs';
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";
import ruleTemp from "@/components/common/ruleTemp.vue";

let sortEl;
export default {
  name: 'intelligentWarehouseRules',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParam: {
        status: -1,
        name: ''
      },
      tableColumns: [
        {
          title: 'No.',
          type: 'index',
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 200,
          align: 'center',
          render: (h, params) => {
            let arr = [];
            arr = [
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')},
                domProps: {
                  innerHTML: (() => {
                    return '&#xe670;';
                  })()
                },
                style: {
                  margin: '0 4px',
                  display: (() => {
                    return v.tableData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'icon iconfont icon-setBottom-copy normalFontSizeTwoSize cursor greenColor',
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, v.tableData.length - 1, params.index);
                  }
                }
              }),
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')},
                domProps: {
                  innerHTML: (() => {
                    return '&#xe63c;';
                  })()
                },
                style: {
                  margin: '0 4px',
                  display: (() => {
                    return v.tableData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'icon iconfont normalFontSizeTwoSize cursor blueColor',
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }),
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005339')},
                style: {
                  margin: '0 4px',
                  position: 'relative',
                  top: '-2px',
                  display: (() => {
                    return v.tableData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'cursor-move grayColor'
              })
            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.tableData.length - 1) {
              arr.splice(0, 1);
            }
            return h('div', {
              style: {
                display: (() => {
                  return v.getPermission('ymsDistributorWarehouseAutoRule_updatePriority') ? 'flex' : 'none';
                })(),
                alignItems: 'center',
                justifyContent: 'center'
              }
            }, arr);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          minWidth: 150,
          align: 'center',
          key: 'name'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005121'),
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return params.row.status === 0 ? h('span', {
              class: 'redColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'greenColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003560'),
          minWidth: 120,
          align: 'center',
          key: 'updatedBy',
          render: (h, params) => {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002971'),
          minWidth: 200,
          align: 'center',
          key: 'updateTime',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operate',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let {autoRuleId, status} = params.row;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsDistributorWarehouseAutoRule_update'),
                    clickFn: () => {
                      v.warehouseRulesBtn('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsDistributorWarehouseAutoRule_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(autoRuleId, 'enable');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsDistributorWarehouseAutoRule_disable'),
                    clickFn: () => {
                      v.enableDisableBtn(autoRuleId, 'disable');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsDistributorWarehouseAutoRule_delete'),
                    clickFn: () => {
                      v.deleteRuleBtn([autoRuleId]);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      statusList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: -1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'), value: 0}
      ],
      ruleType: 'intelligentWarehouseRules',
      userInfoList: {}
    };
  },
  mounted() {
    let v = this;
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    if (v.getPermission('ymsDistributorWarehouseAutoRule_query')) {
      sortEl = v.$refs['dragable'].$children[1].$el.children[1];
      Sortable.create(sortEl, {
        onEnd: v.endFunc
      });
    } else {
      v.gotoError();
    }
  },
  created() {
    getAllUsersInfo().then((data) => {
      this.userInfoList = data;
      this.reset();
      this.search();
    });
  },
  methods: {
    // 查询按钮
    search() {
      this.getList();
    },
    // 重置按钮
    reset() {
      if (this.$refs['pageParam']) {
        this.$refs['pageParam'].resetFields();
      }
      this.search();
    },
    // 获取列表数据
    getList() {
      if (this.getPermission('ymsDistributorWarehouseAutoRule_query')) {
        this.tableData = [];
        this.tableLoading = true;
        this.axios.post(api.post_ymsDistributorWarehouseAutoRule_query, this.pageParam).then(response => {
          if (response.data.code === 0) {
            this.tableData = response.data.datas || [];
            this.tableLoading = false;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
      } else {
        this.gotoError();
      }
    },
    // 启用  停用
    enableDisableBtn(autoRuleId, type) {
      let v = this;
      const configMap = {
        enable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003567'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003568'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485'),
          url: api.put_ymsDistributorWarehouseAutoRule_enable + autoRuleId,
        },
        disable: {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003569'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486'),
          url: api.put_ymsDistributorWarehouseAutoRule_disable + autoRuleId
        }
      };
      const config = configMap[type];
      if (config) {
        let {title, content, successText, url} = config;
        v.$Modal.confirm({
          title: title,
          content: content,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.search();
                v.$Message.success(successText);
              }
            });
          }
        });
      }
    },
    // 删除规则
    deleteRuleBtn(autoRuleIds) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002162'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003570'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsDistributorWarehouseAutoRule + '?autoRuleIds=' + autoRuleIds,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.search();
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
            }
          });
        }
      });
    },
    // 上移、下移
    endFunc(e) {
      let v = this;
      const oldIndex = e.oldIndex;
      const newIndex = e.newIndex;
      let obj;
      if (oldIndex === newIndex) {
        return false;
      }
      // 上移
      if (oldIndex > newIndex) {
        obj = {
          businessId: null,
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          previousId: newIndex > 0 ? v.tableData[newIndex - 1].autoRuleId : null
        };
        if (newIndex >= 0 && newIndex !== v.tableData.length - 1) {
          obj.nextId = v.tableData[newIndex + 1].autoRuleId;
        }
      }
      // 下移
      else {
        obj = {
          businessId: null,
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          previousId: newIndex > 0 ? v.tableData[newIndex].autoRuleId : null
        };
        if (newIndex >= 0 && newIndex !== v.tableData.length - 1) {
          obj.nextId = v.tableData[newIndex + 1].autoRuleId;
        }
      }
      this.updateDataFun(obj);
    },
    // 拖动优先级
    tableSort(autoRuleId, index, oldIndex) {
      let obj = {
        currentId: autoRuleId,
        previousId: index ? this.tableData[index].autoRuleId : null,
        priority: this.tableData[oldIndex].priority
      };
      if (!index && this.tableData.length > 1) {
        obj.nextId = this.tableData[0].autoRuleId;
      }
      this.updateDataFun(obj);
    },
    // 操作更新优先级
    updateDataFun(obj) {
      this.axios.put(api.put_ymsDistributorWarehouseAutoRule_updatePriority, obj).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          this.search();
        }
      });
    },
    // 新增、编辑仓库规则
    warehouseRulesBtn(type, row) {
      let obj = {
        editType: type,
        ...row
      };
      this.$refs['ruleTemp'].open(obj);
    }
  },
  watch: {},
  components: {ruleTemp}
};
</script>

<style lang="less" scoped>
.reset_card_head_style {
  /deep/ .ivu-card-head {
    padding: 7px 16px;
  }
}
</style>
